import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { donotattend, getEventDetailsById } from '../store/event.actions';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-rsvp-unavailabity-confirm',
  templateUrl: './rsvp-unavailabity-confirm.component.html',
  styleUrls: ['./rsvp-unavailabity-confirm.component.scss']
})
export class RsvpUnavailabityConfirmComponent implements OnInit {
  eventId:any;

  isShowForm:boolean=false
  userId:any;
  stopper$: Subject<any> = new Subject();
  EventById:any;
  userProfileImage:any;
  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private store: Store<any>,
    private router:Router
  ) {
    this.activatedRoute.params
      .pipe(takeUntil(this.stopper$))
      .subscribe((params) => {
        console.log(params);
        if (params.event_id && params.user_id) {
          console.log(params)
          this.eventId = params.event_id;
          this.userId = params.user_id;
        }
      });
    this.store.dispatch(new getEventDetailsById(this.eventId));
  }


  ngOnInit() {
    setTimeout(() => {
      this.store
        .select((state) => state.eventManagement.getEventById)
        .subscribe((getEventById: any) => {
          console.log(Object.keys(getEventById).length);
          this.EventById = [];
          if (Object.keys(getEventById).length > 0) {
            this.EventById = getEventById;
            if(this.EventById.profilePic != null){
              this.userProfileImage = `${environment.host}/event/getImage/${this.eventId}`;
            }else{
              this.userProfileImage = null
            }
            if((getEventById.eventStatus == 6 && getEventById.is_active == true) || getEventById.is_active == false){
              this.isShowForm= false   
            }else{
              this.isShowForm= true
            }
          }
        });

    }, 100);
  }

  close(){
    this.store.dispatch(new donotattend(this.eventId,this.userId));
    this.store
    .select((state) => state.eventManagement.donotattendResponse)
    .subscribe((res: any) => {
      if(Object.keys(res).length>0){
        window.close()
      }

    })
   
  }

}
